import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { PermissionCard } from '../cards';

export interface SmartFeatureItem {
  id: string;
  label: string;
  description: string;
  enabled: boolean;
  value: boolean;
}

export interface SmartFeaturesSectionProps {
  items: SmartFeatureItem[];
  onChange: (item: SmartFeatureItem, value: boolean) => void;
}

export const SmartFeaturesSection: React.FC<SmartFeaturesSectionProps> = ({ items, onChange }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
    {items.map((item) => {
      const { id, label, description, enabled, value } = item;
      return (
        <PermissionCard
          key={id}
          label={<Label htmlFor={id} className={enabled ? 'cursor-pointer' : 'cursor-not-allowed text-muted-foreground'}>{label}</Label>}
          description={description}
          dimmed={!enabled}
          onToggle={enabled ? () => onChange(item, !value) : undefined}
          control={
            <Tooltip>
              <TooltipTrigger asChild>
                <div>
                  <Checkbox id={id} checked={value} disabled={!enabled} onCheckedChange={(c) => onChange(item, c as boolean)} />
                </div>
              </TooltipTrigger>
              {!enabled && <TooltipContent><p>This feature must be enabled in General Settings first</p></TooltipContent>}
            </Tooltip>
          }
        />
      );
    })}
  </div>
);
